import { render } from "./이용약관.vue?vue&type=template&id=30bdc5ab"
import script from "./이용약관.vue?vue&type=script&lang=js"
export * from "./이용약관.vue?vue&type=script&lang=js"

import "./이용약관.vue?vue&type=style&index=0&id=30bdc5ab&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__